import { FC } from "react";
import { Stack } from "@chakra-ui/react";
import { RefetchOptions } from "@tanstack/react-query";

import { ErrorComponent } from "../../Errors";

interface Props {
  error: Error | null;
  refetch?: (options?: RefetchOptions | undefined) => Promise<unknown>;
}

export const MainPageCoolingError: FC<Props> = ({ error, refetch }) => {
  return (
    <Stack bg="white" borderRadius="16px" px="20px" pt="0" pb="16px" w="100%">
      <ErrorComponent
        error={error}
        refetch={refetch}
        showGoHomeButton={false}
      />
    </Stack>
  );
};
